/**
 * @file
 * Paragraphs scripts.
 */

// Equalize paragraphs that have class 'cpl-paragraph-equalize'.
const $equalizeParagraph = $('.cpl-paragraph-equalize', context);

$equalizeParagraph.once('equalize-paragraph').each((index, el) => {
  const $this = $(el);
  const $grid = $this.find('.content-grid');
  const paragraphId = $this.data('paragraph-entity-id');

  $this
    .find('.content-grid-item')
    .attr('data-equalizer-watch', `equalize-paragraph-${paragraphId}`);

  $grid.attr({
    'data-equalizer': `equalize-paragraph-${paragraphId}`,
    'data-equalize-on': 'small',
  });

  $grid.foundation();
});

// Equalize text boxes on small screen with slideshow.
const $slideshowParagraph = $(
  '.paragraph--type--imgtxtbanner.cpl-slideshow, .paragraph--type--imgtxt.cpl-slideshow',
  context
);

$slideshowParagraph.once('equalize-text-boxes').each((index, el) => {
  const $this = $(el);
  const $container = $this.find('.content-grid');
  const paragraphId = $this.data('paragraph-entity-id');

  const equalizeTextBoxes = () => {
    if (Foundation.MediaQuery.current === 'small') {
      if (!$container.data(`equalize-slideshow-${paragraphId}`)) {
        $container
          .find('.text-box-row')
          .attr('data-equalizer-watch', `equalize-slideshow-${paragraphId}`);
        $container.attr('data-equalizer', `equalize-slideshow-${paragraphId}`);
        $container.foundation();
      }
    } else {
      $container.find('.text-box-row').removeAttr('data-equalizer-watch style');
      $container.removeAttr('data-equalizer');
    }
  };

  equalizeTextBoxes();
  $(window).resize(equalizeTextBoxes);
});

// Stop video playing when closing video popup.
const $videoModal = $('.video-modal', context);

$videoModal.once('video-modal-close').each((index, el) => {
  const $this = $(el);

  const stopVideo = element => {
    const iframe = element.querySelector('iframe');
    if (iframe) {
      const iframeSrc = iframe.src;
      iframe.src = iframeSrc;
    }
  };

  $this.on('closed.zf.reveal', () => {
    stopVideo($this.get(0));
  });
});

// Video url modifications for ImgtxtBanner.
const $videoBannerIframe = $(
  '.paragraph--type--imgtxtbanner .image-box-video-bg iframe',
  context
);

$videoBannerIframe.once('video-background').each((index, el) => {
  const modifyIframeUrl = $iframe => {
    const iframeSrc = $iframe.attr('src').replace('autoplay=0', 'autoplay=1');
    let iframeSrcNew;

    // Vimeo.
    if ($iframe.closest('.video-embed-field-provider-vimeo').length) {
      iframeSrcNew = `${iframeSrc}&loop=1&muted=1&background=1&autopause=0&fun=false`;
      // YouTube.
    } else if ($iframe.closest('.video-embed-field-provider-youtube').length) {
      iframeSrcNew = `${iframeSrc}&loop=1&showinfo=0&controls=0&disablekb=1`;
    }

    $iframe.attr({ src: iframeSrcNew, allow: 'autoplay; fullscreen' });
  };

  setTimeout(() => {
    modifyIframeUrl($(el));
  }, 250);
});

// Video url modifications for Media Text.
const $mediaTextIframe = $(
  '.paragraph--type--imgtxt .image-box-video iframe',
  context
);

$mediaTextIframe.once('video-frame-style-mediatxt').each((index, el) => {
  const $this = $(el);
  const iframeSrc = $this.attr('src');
  let iframeSrcNew;

  if ($this.closest('.video-embed-field-provider-vimeo').length) {
    iframeSrcNew = `${iframeSrc}&background=1`;
  } else if ($this.closest('.video-embed-field-provider-youtube').length) {
    iframeSrcNew = `${iframeSrc}&modestbranding=1&controls=0&fs=0&rel=0`;
  }

  $this.attr({ src: iframeSrcNew });
});

// Start autoplay of videos in paragraph, when option is selected.
const $videoAutoplay = $('.cpl-video-autoplay', context);
$videoAutoplay.once('paragraph-video-autoplay').each((index, el) => {
  const $this = $(el);
  // Autoplay all videos.
  if ($this.hasClass('cpl-alternating')) {
    const $videos = $this.find('iframe');
    $videos.each((i, e) => {
      $(e).attr({
        src: $(e)
          .attr('src')
          .replace('autoplay=0', 'autoplay=1'),
        allow: 'autoplay; fullscreen',
      });
    });
  } else {
    // Autoplay only first video.
    const $videoFirst = $this.find('iframe').eq(0);
    $(window).scroll(() => {
      if (
        $(window).scrollTop() > $this.offset().top - 200 &&
        $this.attr('data-autoplay-started') === undefined
      ) {
        $videoFirst.attr({
          src: $videoFirst.attr('src').replace('autoplay=0', 'autoplay=1'),
          allow: 'autoplay; fullscreen',
        });
        $this.attr({ 'data-autoplay-started': '' });
      }
    });
  }
});

// Remove view reference title for blog.
const $viewReferenceTitle = $('.cpl-blog-page-block', context);

$viewReferenceTitle.once('view-reference-title').each((index, el) => {
  $(el)
    .parent()
    .siblings('.viewsreference--view-title')
    .css('display', 'none');
});

// Default background image height.
const $imageBackground = $(
  '.paragraph--type--imgtxtbanner .image-box-bg, .paragraph--type--imgtxt .image-box-bg',
  context
);

$imageBackground.once('height-default-image-bg').each((index, el) => {
  const $this = $(el);
  const $parentParagraph = $this.parents('.paragraph');

  if (
    !$parentParagraph.hasClass('[class^="cpl-banner"]') ||
    !$parentParagraph.hasClass('[class^="cpl-image"]')
  ) {
    $this.css('min-height', `${$this.attr('data-image-height')}px`);
  }
});
